import React from "react";
import { useSelector } from "react-redux";
import Layout from "../components/FormNav/Layout";

const LayoutWithRole = () => {
  const { availableRoles } = useSelector((state) => state.auth);
  const userType = availableRoles?.toLowerCase();

  return <Layout userType={userType} />;
};

export default LayoutWithRole;
